import { PrimitiveType, useIntl } from "react-intl";
import { MergeTranslateKeys } from "./keys";

export function useTranslate() {
  const intl = useIntl();

  return (
    id: keyof MergeTranslateKeys,
    values?: Record<string, PrimitiveType>
  ) => intl.formatMessage({ id }, values);
}